import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../constants/api';
import ContactLogo from '../components/shared/ContactLogo';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-full overflow-hidden mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <ContactLogo clickable={true} />
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/login')}
                className="text-black hover:text-gray-600 px-4 py-2 text-sm font-medium transition-colors"
              >
                Iniciar Sesión
              </button>
              <button
                onClick={() => navigate('/register')}
                className="btn-primary"
              >
                Comenzar
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="bg-gradient-contact">
        <div className="max-w-full overflow-hidden mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold text-black sm:text-5xl md:text-6xl">
              <span className="block">El futuro del</span>
              <span className="block text-sky-300">networking profesional</span>
            </h1>
            <p className="mt-6 max-w-2xl mx-auto text-xl text-gray-600 leading-relaxed">
              Reemplaza las tarjetas de presentación tradicionales con tarjetas inteligentes NFC. 
              Una solución moderna, ecológica y profesional para el networking corporativo.
            </p>
            <div className="mt-10">
              <button
                onClick={() => navigate('/register')}
                className="btn-primary btn-hover text-lg px-8 py-4 shadow-lg"
              >
                Crear mi perfil digital
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-full overflow-hidden mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-black">¿Por qué elegir CONTACT?</h2>
          </div>
          <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
            <div className="text-center">
              <div className="mx-auto h-20 w-20 bg-sky-300 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <svg className="h-10 w-10 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-black mb-4">Tecnología NFC</h3>
              <p className="text-gray-600 leading-relaxed">
                Solo acerca tu tarjeta a cualquier celular y comparte tu información al instante.
              </p>
            </div>
            <div className="text-center">
              <div className="mx-auto h-20 w-20 bg-sky-300 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <svg className="h-10 w-10 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-black mb-4">Actualizable</h3>
              <p className="text-gray-600 leading-relaxed">
                Modifica tu información cuando quieras desde tu panel de control.
              </p>
            </div>
            <div className="text-center">
              <div className="mx-auto h-20 w-20 bg-sky-300 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <svg className="h-10 w-10 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-black mb-4">Analytics Avanzados</h3>
              <p className="text-gray-600 leading-relaxed">
                Conoce qué tan efectivo es tu networking con métricas detalladas.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-100">
        <div className="max-w-full overflow-hidden mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="text-right">
            <p className="text-gray-400 text-sm" style={{ opacity: 0.7 }}>
              Powered by Contact
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Login Component
// Forgot Password Modal Component

// Public Forgot Password Page Component

export default LandingPage;
